// extracted by mini-css-extract-plugin
export default {"h2":"Gallery_h2__IfJ1t","h4":"Gallery_h4__T71-+"};